import { ProportionalAllocator } from "./proportional-allocator";
import { Util } from "../../../../util/util";
// This before tax allocator was derived from the original code where it applies to the following coupon types:
// explicitly: QUANTITY_DISCOUNT
//
// Legacy (`_splitDiscountBeforeTax`) gives QUANTITY_DISCOUNT its own branch: when the coupon price
// beats the configured discount, the item takes a flat (discount / halfCount) off — the amount is not
// proportional to the item price and is never redistributed. Note the gate compares cPrice against the
// *whole* configured discount while the amount taken is divided by halfCount; that asymmetry is
// intentional here because it is what the legacy split does.
//
// Items that fail the gate but still have a coupon price fall through to legacy's shared
// `_applyBeforeTaxDiscount`, i.e. the proportional allocation.
export class QuantityDiscountAllocator {
    _proportionalAllocator = new ProportionalAllocator();
    allocate(params) {
        const { dItem, configuredDiscountValue } = params;
        const configuredDiscount = configuredDiscountValue ?? 0;
        if (dItem.cPrice > configuredDiscount) {
            const halfCount = dItem.halfCount ?? 1;
            const amt = Util.Float2(configuredDiscount / halfCount);
            dItem.beforeTaxDiscount += amt;
            return {
                allocated: amt,
                wantsRedistribute: 0,
                // Legacy neither marks this item for the rounding fix-up nor keeps it in the
                // redistribution pool, so it is not eligible for either here.
                eligibleForRounding: false,
            };
        }
        if (dItem.cPrice > 0)
            return this._proportionalAllocator.allocate(params);
        return {
            allocated: 0,
            wantsRedistribute: 0,
            eligibleForRounding: false,
        };
    }
}
//# sourceMappingURL=quantity-discount-allocator.js.map